import { api } from '../../services/api';
import * as types from '../Constants';
import { getCached, setCache } from '../../Common/apiCache';

export const getCompany = () => {
  const cached = getCached('company');
  if (cached) {
    return (dispatch) =>
      Promise.resolve(dispatch({ type: types.COMPANY_SUCCESS, payload: cached }));
  }
  const options = {
    url: 'v1/company',
  };
  options.types = [types.COMPANY_SUCCESS, types.COMPANY_FAILURE];
  const apiAction = api.get(options);
  return (dispatch) =>
    apiAction(dispatch).then((result) => {
      if (result && result.payload) setCache('company', result.payload);
      return result;
    });
};

export const updCompany = (data) => {
  var userId = localStorage.getItem('userId');
  const options = {
    url: 'v1/company',
  };

  options.types = [types.UPDATE_COMPANY_SUCCESS, types.UPDATE_COMPANY_FAILURE];

  return api.put(options, data);
};
